import type { Dispatch, SetStateAction } from "react";
import { useRef } from "react";

import useScrollHashTab from "../../../hooks/useScrollHashTab";
import type { RatingCategory } from "../../../types";
import TabSwitch from "./TabSwitch";
import useStickyTabHeader from "./useStickyTabHeader";

interface RatingPageTabSwitchProps {
  ratingList: RatingCategory[];
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
}

function RatingPageTabSwitch({
  ratingList,
  searchQuery,
  setSearchQuery,
}: RatingPageTabSwitchProps) {
  const { handleSetActiveTabId, activeTabId } = useScrollHashTab(
    ratingList,
    "rating-section",
  );
  const containerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useStickyTabHeader(containerRef, innerRef);

  return (
    <div ref={containerRef}>
      <div
        ref={innerRef}
        style={{ willChange: "position", transition: "none" }}
      >
        <div className="bg-white w-full">
          <div className="container-lg mx-auto 2xl:px-0 lg:px-4 md:px-4 px-4 md:pt-4 md:pb-3">
            <div className="flex gap-5">
              <div className="flex-1">
                <TabSwitch
                  ratingList={ratingList}
                  setActiveId={handleSetActiveTabId}
                  activeTabId={activeTabId}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </div>
              <div className="text-right hidden md:flex items-center justify-center">
                <a
                  target="_blank"
                  href="https://t.me/vpn_ru_net_bot"
                  className="font-bold text-base"
                  rel="noreferrer"
                  data-umami-event="Rating Page Bot Click"
                >
                  Не нашли свой сервис?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RatingPageTabSwitch;
